import { render, staticRenderFns } from "./qrCode.vue?vue&type=template&id=220e495d&scoped=true"
import script from "./qrCode.vue?vue&type=script&lang=js"
export * from "./qrCode.vue?vue&type=script&lang=js"
import style0 from "./qrCode.vue?vue&type=style&index=0&id=220e495d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220e495d",
  null
  
)

export default component.exports